<template>
  <div>
    <b-form @submit="handleSubmit">
      <b-form-group id="phraseName"
                    label="Name"
                    label-for="phraseNameInput"
      >
        <b-form-input id="phraseNameInput"
                      v-model="form.name"
                      type="text"
                      :state="!$v.form.name.$invalid"
                      aria-describedby="phraseNameInputLiveFeedback"
                      required
                      placeholder="Name der Phrase"
        />
        <b-form-invalid-feedback id="phraseNameInputLiveFeedback">
          Der Name der Phrase muss mind. 3 Zeichen lang sein
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group id="phraseDescription"
                    label="Beschreibung"
                    label-for="phraseDescriptionInput"
      >
        <b-form-input id="phraseDescriptionInput"
                      v-model="form.description"
                      type="text"
                      :state="!$v.form.description.$invalid"
                      aria-describedby="phraseDescriptionInputLiveFeedback"
                      placeholder="Beschreibung (optional)"
        />
        <b-form-invalid-feedback id="phraseDescriptionInputLiveFeedback">
          Die Beschreibung darf nicht länger als 1.000 Zeichen sein.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group id="phraseContent"
                    label="Inhalt"
                    label-for="phraseContentInput"
      >
        <b-form-textarea id="phraseContentInput"
                         v-model="form.content"
                         type="textarea"
                         placeholder="Inhalt der Phrase"
                         :rows="3"
                         :max-rows="50"
        />
      </b-form-group>
      <b-button variant="primary" type="submit" :disabled="$v.form.$invalid">
        Speichern
      </b-button>
    </b-form>
  </div>
</template>

<script>

import { validationMixin } from "vuelidate"
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  data () {
    return {
      form: {
        name: '',
        description: '',
        content: '',
      },
      formInitialData: {}
    }
  },
  computed: {
    editItem () {
        return this.$store.state.activeModalContent
    }
  },
  created() {
    if ( this._.has(this.$store.state.phrases, this.editItem) ){
      this.formInitialData = this.$store.state.phrases[this.editItem]

      this.form.name = this.formInitialData.name
      this.form.description = this.formInitialData.description
      this.form.content = this.formInitialData.content
    }
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(300)
      },
      description: {
        maxLength: maxLength(1000)
      }
    }
  },
  methods: {
    handleSubmit(evt){
      evt.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) {
        return
      }
      this.updatePhrase(this.editItem, this.form)
    },
    updatePhrase( id, data ){
      this.$spinnaApi.put('/private/phrase/' + id, data).then((response) => {
        if(response.data.status == '200'){
          this.$store.dispatch('GET_ALL_PHRASES')
          this.$store.commit('SET_ACTIVE_MODAL', null)
          this.$store.commit('SET_ACTIVE_MODAL_CONTENT', null)
        }
        else {
          // Keine Änderungen gespeichert
        }

      }).catch((e) => { console.log(e) })
    },
  }
}
</script>
